import { render, staticRenderFns } from "./datasource-direct-collect-method-form.vue?vue&type=template&id=96a05d16"
import script from "./datasource-direct-collect-method-form.vue?vue&type=script&lang=js"
export * from "./datasource-direct-collect-method-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports